import { useRef } from "react"

export default function useConstant(init, { ssr = true } = {}) {
  const ref = useRef(null)
  if (ref.current === null && (process.browser || (!process.browser && ssr))) ref.current = init()
  return ref.current
}
